<form [ngClass]="themeClass" (ngSubmit)="saveChanges()">
  <div class="mini-header light-text-color">Task:</div>
  <div class="task-header dark-text-color">"{{ title }}"</div>

  <div class="sub-header">
    <mat-checkbox [checked]="setDueTime" (change)="clickSetDue($event.checked)">
      Due
    </mat-checkbox>
  </div>
  <div *ngIf="setDueTime">
    <mat-form-field [floatLabel]="'always'" class="date-form-field">
      <mat-label>Date (MM/DD/YYYY) </mat-label>
      <input
        matInput
        [matDatepicker]="duePicker"
        [formControl]="dueDateControl"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="duePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #duePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field [floatLabel]="'always'" class="time-form-field">
      <mat-label>Time (hh:mm {{ hour12 ? ' pm' : '' }})</mat-label>
      <input
        matInput
        placeholder="hh:mm {{ hour12 ? ' pm' : '' }}"
        [formControl]="dueTimeControl"
      />
    </mat-form-field>
  </div>

  <div class="mini-header light-text-color">Schedule</div>

  <div class="sub-header">
    <mat-checkbox
      [checked]="setStartTime"
      (change)="clickSetStart($event.checked)"
    >
      Start time
    </mat-checkbox>
  </div>
  <div *ngIf="setStartTime">
    <mat-form-field [floatLabel]="'always'" class="date-form-field">
      <mat-label>Date (MM/DD/YYYY) </mat-label>
      <input
        matInput
        [matDatepicker]="startPicker"
        [formControl]="startDateControl"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="startPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field [floatLabel]="'always'" class="time-form-field">
      <mat-label>Time (hh:mm {{ hour12 ? ' pm' : '' }})</mat-label>
      <input
        matInput
        placeholder="hh:mm {{ hour12 ? ' pm' : '' }}"
        [formControl]="startTimeControl"
      />
    </mat-form-field>
  </div>

  <div *ngIf="setStartTime" class="sub-header">
    <mat-checkbox [checked]="setEndTime" (change)="clickSetEnd($event.checked)">
      End time
    </mat-checkbox>
  </div>
  <div *ngIf="setEndTime">
    <mat-form-field [floatLabel]="'always'" class="date-form-field">
      <mat-label>Date (MM/DD/YYYY) </mat-label>
      <input
        matInput
        [matDatepicker]="endPicker"
        [formControl]="endDateControl"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="endPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field [floatLabel]="'always'" class="time-form-field">
      <mat-label>Time (hh:mm {{ hour12 ? ' pm' : '' }})</mat-label>
      <input
        matInput
        placeholder="hh:mm {{ hour12 ? ' pm' : '' }}"
        [formControl]="endTimeControl"
      />
    </mat-form-field>
  </div>

  <p *ngIf="showEndBeforeError" class="text-error-color">
    End time cannot be before start time.
  </p>

  <p *ngIf="showMoveToCurrentWarning" class="light-text-color">
    If the scheduled start is in the past or in the next 12 hours, the task will
    immediately be set as "current".
  </p>

  <!-- TODO: add this note when this feature is added -->
  <!-- <p class="light-text-color">
    Setting a start time will cause the task to be automatically moved into the
    "current tasks" section about 12 hours before it starts.
  </p> -->

  <div class="button-div">
    <button
      mat-raised-button
      color="primary"
      [disabled]="disableSubmit"
      type="submit"
      value="submit"
    >
      Update
    </button>
  </div>
</form>
